import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import DetailsTable from '../../../../../components/CustomTable/DetailsTable';
import CustomTableOffcanvas from '../../../../../components/CustomTableOffcanvas';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../../modules/contexts/Select/useSelect';
import { getOrgIntersByUsuario } from '../../../../../services/orgInters/orgIntersService';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../../utils/functions';
import { SubAbas as subAbas } from '../../subabas';
import {
  headersOrgIntersCustomTable,
  OrgIntersTableRow,
  valoresExibidosOffCanvasOrgInters,
} from '../utils/auxiliarOrgInters';

const OrgIntersListagem: React.FC = () => {
  //DADOS USUARIO
  const user = getUser();

  const { getSelectDominioPai } = useSelect();
  const statusVigenciaOptions = getSelectDominioPai(52);
  const componenteAFoptions = getSelectDominioPai(1);
  const orgInternacionalOptions = getSelectDominioPai(161);

  const [data, setData] = useState<any[]>([]);

  const fetchData = async () => {
    try {
      const registros = await getOrgIntersByUsuario();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  // USE EFFECT
  useEffect(() => {
    fetchData();
  }, []);

  // TABELA E OFFCANVAS
  const tableData = data.map((item) => ({
    id: item?.id ?? 'Não informado',

    statusOrgInter:
      statusVigenciaOptions.find(
        (status) => status.value === Number(item.statusOrgInter),
      )?.label ?? 'Não informado',
    componenteAf:
      componenteAFoptions.find(
        (componenteAf) => componenteAf.value === item.componenteAf,
      )?.label ?? 'Não informado',
    orgInternacional:
      orgInternacionalOptions.find(
        (option) => Number(option.value) === Number(item.orgInternacional),
      )?.label ?? 'Não informado',
    numeroTC: item?.numeroTC ?? 'Não informado',
    nupTermoAjuste: item?.nupTermoAjuste ?? 'Não informado',
    dataInicio: item?.dataInicio
      ? formatDateSimp(item.dataInicio)
      : 'Não informado',
    dataVigencia: item?.dataVigencia
      ? formatDateSimp(item.dataVigencia)
      : 'Não informado',
  }));

  const offCanvasData = data.map((item) => {
    const statusLabel = statusVigenciaOptions.find(
      (option) => option.value === item.statusOrgInter,
    )?.label;

    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro?.nomeCompleto ?? ''),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao?.nomeCompleto ?? ''),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(
          item.usuarioUltimaVisualizacao?.nomeCompleto ?? '',
        ),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      statusOrgInter: statusLabel,
      componenteAf: componenteAFoptions.find(
        (option) => option.value === item.componenteAf,
      )?.label,

      orgInternacional:
        orgInternacionalOptions.find(
          (option) => option.value === item.orgInternacional,
        )?.label ?? 'Não informado',
      numeroTC: item.numeroTC ?? 'Não informado',
      nupTermoAjuste: item.nupTermoAjuste ?? 'Não informado',
      dataInicio: formatDateSimp(item.dataInicio),
      dataVigencia: formatDateSimp(item.dataVigencia),
      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const navigate = useNavigate();

  const handleClickInserir = () => {
    navigate('dadosgerais');
  };

  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);
  const offcanvasOpenRoute = useMemo(() => {
    if (!selectedDetailsRowId) return undefined;

    const baseHash = window.location.hash.replace(/\/$/, '');
    return `${baseHash}/${selectedDetailsRowId}/dadosgerais`;
  }, [selectedDetailsRowId]);

  const handleOpenDetails = (row: OrgIntersTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const handleTableRowClick = (row: OrgIntersTableRow) => {
    if (row?.id) {
      navigate(`${row.id}/dadosgerais`);
    }
  };

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersOrgIntersCustomTable}
          data={tableData}
          displayValues={valoresExibidosOffCanvasOrgInters}
          offcanvasTitle="Org. Internacionais - Detalhes"
          widthOffcanvas="50%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={50}
          // emptyMessage="Carregando..."
          showPagination={true}
          showOpenButton={true}
          filterable={true}
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresExibidosOffCanvasOrgInters}
            />
          )}
        </CustomTableOffcanvas>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes inserir onClickInserir={handleClickInserir} />
      </BarraInferiorBotoes>
    </>
  );
};

export default OrgIntersListagem;
